import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

const WHATSAPP_URL = 'https://wa.me/917398073200?text=I%20want%20a%20free%20menu%20audit';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: t.nav.features, href: '#features' },
    { name: t.nav.howItWorks, href: '#how-it-works' },
    { name: t.nav.pricing, href: '#pricing' },
    { name: t.nav.faq, href: '#faq' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'glass py-3' : 'py-5 bg-transparent'
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-testid="navbar-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_aifood-photos/artifacts/qg73uxzb_ChatGPT%20Image%20Feb%202%2C%202026%2C%2002_28_25%20PM.png" 
              alt="MenuRank AI"
              className="w-10 h-10 rounded-xl object-contain group-hover:scale-110 transition-transform duration-200"
            />
            <span className="text-xl font-semibold text-white">MenuRank AI</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="text-white/70 hover:text-white transition-colors duration-200 text-sm font-medium"
                data-testid={`nav-link-${index}`}
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Language Toggle & CTA */}
          <div className="flex items-center gap-3">
            {/* CTA Button - Desktop */}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:inline-block btn-primary text-sm"
              data-testid="navbar-cta"
            >
              {t.nav.contactNow}
            </a>

            {/* Mobile CTA */}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="md:hidden btn-primary text-xs px-3 py-2"
              data-testid="mobile-cta"
            >
              {t.nav.contactNow}
            </a>
          </div>
        </div>
      </div>
    </motion.nav>
  );
};
